module.exports = __webpack_public_path__ + "static/media/granted.a158deee.wav";